<ion-header no-border="" no-shadow>
  <ion-toolbar no-border>
    <ion-buttons slot="start" class="back-button-section">
      <ion-back-button
        onclick="event.stopImmediatePropagation();"
        (mouseup)="closeModal($event)"
        defaultHref=""
        color="dark"
        [icon]="'ios-arrow-back'"
        [text]="''"
      ></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end" class="close-button-section">
      <ion-button (click)="closeModal()">
        <ion-icon
          color="medium"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title text-left no-padding-start>
      <div class="modal-title-text">
        <ion-icon
          [src]="'assets/rcyl-orders/lorry-receipt.svg'"
          color="primary"
        ></ion-icon
        >&nbsp;
        <ion-text font-bold="" color="dark">Transportation Details</ion-text>
      </div>
    </ion-title>
    <!--<ion-title text-left no-padding-start *ngIf="componentView ==='VIEW_UPLOAD'">
          <div class="modal-title-text">
            <ion-icon [src]="orderDocumentsMap[activeDocumentType]?.icon" color="primary"></ion-icon>&nbsp;
            <ion-text font-bold="" color="dark">{{orderDocumentsMap[activeDocumentType]?.displayText}}</ion-text>
          </div>
        </ion-title>-->
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="transportationDetailsForm"
    [ngClass]="channelType === 'STARGAZE' ? 'custom-input-fields' : ''"
  >
    <ion-grid>
      <ion-row>
        <ion-col size="12" *ngIf="channelType != 'STARGAZE'">
          <ion-item
            lines="none"
            input-item=""
            formGroupName="logisticsTransporters"
          >
            <ion-label position="stacked">Transporter Name</ion-label>
            <ion-select
              formControlName="id"
              *ngIf="transporters"
              interface="action-sheet"
              placeholder="Select transporter name"
            >
              <ion-select-option
                *ngFor="let transporter of transporters"
                [value]="transporter?.value"
                >{{ transporter?.label }}</ion-select-option
              >
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col
          size="6"
          *ngIf="channelType === 'STARGAZE'"
          formGroupName="logisticsTransporters"
        >
          <ion-label position="stacked" class="label-position"
            >Transporter Name</ion-label
          >
          <div *ngIf="transporters">
            <p-dropdown
              placeholder="Select transporter name"
              [options]="transporters"
              name="id"
              formControlName="id"
            ></p-dropdown>
          </div>
        </ion-col>
        <ion-col size="12" *ngIf="channelType != 'STARGAZE'">
          <ion-item lines="none" input-item="" formGroupName="logisticsVehicle">
            <ion-label position="stacked">Vehicle Type</ion-label>
            <ion-select
              formControlName="id"
              *ngIf="vehicleTypes"
              interface="action-sheet"
              placeholder="Select the vehicle type"
              (ionChange)="
                updateVehicleCapacity(
                  transportationDetailsForm?.value?.logisticsVehicle?.id
                )
              "
            >
              <ion-select-option
                *ngFor="let vehicleType of vehicleTypes"
                [value]="vehicleType?.id"
                >{{ vehicleType?.vehicleType }}</ion-select-option
              >
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col
          size="6"
          *ngIf="channelType === 'STARGAZE'"
          formGroupName="logisticsVehicle"
        >
          <ion-label position="stacked" class="label-position"
            >Vehicle Type</ion-label
          >
          <div>
            <p-dropdown
              placeholder="Select the vehicle type"
              *ngIf="vehicleTypes"
              [options]="vehicleTypes"
              (onChange)="
                updateVehicleCapacity(
                  transportationDetailsForm?.value?.logisticsVehicle?.id
                )
              "
              formControlName="id"
            ></p-dropdown>
          </div>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Vehicle Capacity</ion-label>
            <ion-input
              formControlName="vehicleCapacity"
              type="number"
              placeholder="Enter the capacity in tonnes"
            >
              <ion-text class="text-right" color="medium">Tonnes</ion-text>
            </ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Vehicle Number</ion-label>
            <ion-input
              formControlName="vehicleNumber"
              type="text"
              placeholder="Enter the number"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked"
              >Validity of National Permit/State Permit</ion-label
            >
          </ion-item>
          <ion-radio-group formControlName="vehiclePermit">
            <ion-row no-padding>
              <ion-col size="4" no-padding>
                <ion-item lines="none" input-item="">
                  <ion-label>Yes</ion-label>
                  <ion-radio slot="start" [value]="true"></ion-radio>
                </ion-item>
              </ion-col>
              <ion-col size="4" no-padding>
                <ion-item lines="none" input-item="">
                  <ion-label>No</ion-label>
                  <ion-radio slot="start" [value]="false"></ion-radio>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-radio-group>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Insurance Available</ion-label>
          </ion-item>

          <ion-radio-group formControlName="vehicleInsurance">
            <ion-row no-padding>
              <ion-col size="4" no-padding>
                <ion-item lines="none" input-item="">
                  <ion-label>Yes</ion-label>
                  <ion-radio slot="start" [value]="true"></ion-radio>
                </ion-item>
              </ion-col>
              <ion-col size="4" no-padding>
                <ion-item lines="none" input-item="">
                  <ion-label>No</ion-label>
                  <ion-radio slot="start" [value]="false"></ion-radio>
                </ion-item>
              </ion-col>
            </ion-row>
          </ion-radio-group>
        </ion-col>
        <ion-col
          size="12"
          class="section-separator"
          margin-top
          text-center
          padding-start
          padding-top
          padding-end
        >
          <ion-label>Driver information</ion-label>
          <!--<p class="section-separator"><span></span></p>-->
        </ion-col>
        <div></div>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Driver Name</ion-label>
            <ion-input
              formControlName="driverName"
              placeholder="Enter the driver’s name"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Driver Mobile Number</ion-label>
            <ion-input
              type="phone"
              placeholder="Enter the driver’s mobile number"
              formControlName="driverContact"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" *ngIf="channelType != 'STARGAZE'">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">ID Proof</ion-label>
            <ion-select
              interface="action-sheet"
              placeholder="Select the ID proof type"
              formControlName="idProof"
            >
              <ion-select-option
                *ngFor="let idType of idProofTypes"
                [value]="idType?.value"
              >
                {{ idType?.label }}
              </ion-select-option>
            </ion-select>
            <ion-input
              [hidden]="!transportationDetailsForm?.value?.idProof"
              type="text"
              placeholder="Enter the ID proof number"
              formControlName="idProofNo"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col size="12" *ngIf="channelType === 'STARGAZE'">
          <ion-row>
            <ion-col size="6" style="margin-top: 6px">
              <ion-label class="label-position">ID Proof</ion-label>
              <div>
                <p-dropdown
                  placeholder="Select the ID proof type"
                  *ngIf="idProofTypes"
                  [options]="idProofTypes"
                  formControlName="idProof"
                ></p-dropdown>
              </div>
            </ion-col>
            <ion-col size="6">
              <ion-item
                lines="none"
                input-item
                [hidden]="!transportationDetailsForm?.value?.idProof"
              >
                <ion-label position="stacked">ID Number</ion-label>
                <ion-input
                  type="text"
                  placeholder="Enter the ID proof number"
                  formControlName="idProofNo"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <ion-item lines="none" input-item="">
            <ion-label position="stacked">Driving License</ion-label>
            <ion-input
              formControlName="driverLicenceNo"
              placeholder="Enter the driving license number"
              type="text"
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
  <!--<ion-grid no-padding>
      <ion-row no-padding>
        <ion-col size="12" no-padding-left="" no-padding-right="" no-padding-bottom="" padding-top="">
          <ion-row219027
          >
            <ion-col size="10" text-left="">
              <ion-text color="medium" class="to-from-location" font-bold>Dispatched From
              </ion-text>
              <br/>
              <ion-text color="dark"
                        class="location-name">{{orderDetails?.fromLocation?.name | uppercase}}</ion-text>
              <br/>
              <ion-text color="dark" font-bold
                        class="street">{{orderDetails?.fromLocation?.addressInfo?.landmark ? orderDetails?.fromLocation?.addressInfo?.landmark + ',' : '' }} {{orderDetails?.fromLocation?.addressInfo?.street}}</ion-text>
            </ion-col>
          </ion-row>
        </ion-col>
        <ion-col size="12" no-padding="" *ngIf="orderDetails?.status === 'SETTLED'">
          <ion-row>
            <ion-col size="10" text-left="">
              <ion-label color="medium" class="to-from-location" font-bold>Delivered At
              </ion-label>
              <br/>
              <ion-text color="dark"
                        class="location-name">{{orderDetails?.toLocation?.name | uppercase}}</ion-text>
              <br/>
              <ion-text color="dark" font-bold
                        class="street">{{orderDetails?.toLocation?.addressInfo?.landmark ? orderDetails?.toLocation?.addressInfo?.landmark + ',' : '' }} {{orderDetails?.toLocation?.addressInfo?.street}}</ion-text>
            </ion-col>
            &lt;!&ndash;<ion-col size="2" *ngIf="order?.status === 'CREATED'">
                <ion-button float-end="" color="light" size="small" fill="outline">EDIT</ion-button>
            </ion-col>&ndash;&gt;
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>-->
</ion-content>
<ion-footer>
  <ion-row>
    <ion-col size="12" text-center>
      <ion-button
        [disabled]="
          !transportationDetailsForm.touched ||
          transportationDetailsForm.invalid
        "
        (click)="saveLogisticDetails()"
        size="large"
        *ngIf="!orderLogisticsDetails?.id"
      >
        Save
      </ion-button>
      <ion-button
        [disabled]="transportationDetailsForm.invalid"
        (click)="updateLogisticDetails()"
        size="large"
        *ngIf="orderLogisticsDetails?.id"
      >
        Update
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>
